// @ts-nocheck
import { makeStyles, createMuiTheme } from '@material-ui/core/styles';
import theme from '../../../theme';

export const useStyles = makeStyles(() => ({
  datePicker: {
    backgroundColor: 'rgba(44, 148, 167, 0.1)',
    flexDirection: 'unset',
  },
  value: {
    backgroundColor: 'rgba(44, 148, 167, 0.1)',
  },
}));

export const datePickerTheme = createMuiTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: theme.palette.common.white,
      },
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: '2px',
        fontFamily: 'fs-elliot-pro-bold',
        minWidth: '18rem',
        '& $notchedOutline': {
          border: `2px solid ${theme.palette.secondary.dark}`,
        },
        '&:hover $notchedOutline': {
          borderColor: theme.palette.common.black,
        },
        '&$focused $notchedOutline': {
          border: `2px solid ${theme.palette.secondary.dark}`,
        },
        '&$error $notchedOutline': {
          borderColor: theme.palette.utility.redLight,
          boxShadow: `inset 0 0 0 2px ${theme.palette.utility.redDark}`,
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: `${theme.palette.utility.redLight}`,
          },
        },
      },
    },
    MuiPickersToolbarText: {
      toolbarTxt: {
        color: theme.palette.common.black,
      },
      toolbarBtnSelected: {
        color: theme.palette.common.black,
        fontSize: '1.5rem',
        fontWeight: 700,
      },
    },
    MuiPickersDay: {
      daySelected: {
        backgroundColor: theme.palette.primary.dark,
      },
      dayDisabled: {
        color: theme.palette.dark[50],
      },
      current: {
        color: theme.palette.common.black,
      },
    },
  },
  palette: {
    primary: {
      main: theme.palette.common.black,
    },
  },
  shape: {
    borderRadius: 0,
  },
});
